var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.overlay)?_c('div',{staticClass:"a-loading-spinner__overlay",class:{ 'a-loading-spinner__overlay--login': _vm.login }}):_vm._e(),_c('div',{staticClass:"a-loading-spinner__loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }